import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import { Box, Typography } from '@mui/material';
import TileTitle from '../../common/tileTitle';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import dayjs from "dayjs";
import { ToggleButton, ToggleButtonGroup } from "../../common/CustomToggleButton";


const MLineChartWithTitle = ({ height, width, title, chartData, chart_id, maxYaxis ,totalArea}) => {

  console.log(totalArea)

  const [checked, setChecked] = React.useState("월간");
  const chartData2 = checked === "주간" ? chartData.week : chartData.month;

  const onCheckedChange = (event, selectedValue) => {
    if (selectedValue !== null) {
      setChecked(selectedValue);
    }
  };

  const unit = chartData2 && chartData2[0]?.unit;

   useEffect(() => {

    if (!chartData2 || chartData2.length === 0) return;

    const groupedData = _.groupBy(chartData2, 'date');

    const summarizedData = Object.entries(groupedData).map(([date, values]) => {
      const roomData = _.groupBy(values, 'room');
      const summarizedRoomData = Object.entries(roomData).reduce((acc, [room, roomValues]) => {
        acc[room] = _.sumBy(roomValues, 'MD');
        return acc;
      }, {});
    
      const totalMD = _.sum(Object.values(summarizedRoomData));
      const firstArea = values[0].Area; // Assume all values have the same Area value
    
      return {
        date,
        ...Object.entries(summarizedRoomData).reduce((acc, [room, md]) => {
          acc[room] = firstArea !== null && firstArea !== 0 ? md / firstArea : null;
          return acc;
        }, {}),
      };
    });

    var root = am5.Root.new(chart_id);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: "panX",
      wheelY: "zoomX",
      pinchZoomX: true,
      paddingLeft: 0
    }));

    chart.zoomOutButton.set("forceHidden", true);
    // chart.plotContainer.onPrivate("height", function(height) {
    //   chart.zoomOutButton.set("dy", height - 45);
    //   chart.zoomOutButton.set('scale',0.8)

    // });

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineX.set("forceHidden", true);
    cursor.lineY.set("forceHidden", true);

    let xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 30,
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      strokeOpacity: 0,
      // strokeWidth: 1,
      // stroke: "rgba(224, 224, 224, 0.5)",
    });

    var xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "date",
        renderer: xRenderer
      })
    );


    xRenderer.grid.template.setAll({
      location: 1,
      strokeOpacity: 0,
    });


    xRenderer.labels.template.adapters.add("text", (text, target) => {
      if (target.dataItem) {

        const category = target.dataItem.dataContext.date;

        if (category.includes("월")) {
          const date = dayjs(category, "YY년 MM월");

          const valueList = target.dataItem.component._data._values;
          const categoryIndex = _.findIndex(valueList, { date: category })

          const year = date.year();
          const month = date.month() + 1;

          if (categoryIndex === 0 || year !== dayjs(target.dataItem.component._data._values[categoryIndex - 1]?.date, "YY년 MM월").year()) {
            return category.split(" ")[0];
          } else {
            return `${month}월`;
          }
        } else {
          const date = dayjs(category, "YY년 WW주차");

          const valueList = target.dataItem.component._data._values;
          const categoryIndex = _.findIndex(valueList, { date: category })

          const year = date.year();

          if (categoryIndex === 0 || year !== dayjs(target.dataItem.component._data._values[categoryIndex - 1]?.date, "YY년 WW주차").year()) {
            return category.split(" ")[0];
          } else {
            return category.split(" ")[1].slice(0, 3);
          }
        }
        return text;
      }
    });

    // Set the data on the xAxis
    xAxis.data.setAll(summarizedData);


    xAxis.get("renderer").labels.template.setAll({
      // oversizedBehavior: "fit",
      oversizedBehavior: "wrap",
      textAlign: "center",
      fill: "#525252",
      maxWidth: 50,
      fontSize: "0.8rem",
      minScale: 0.6
    });

    let yRenderer = am5xy.AxisRendererY.new(root, {
      strokeOpacity: 1,
      strokeWidth: 1,
      stroke: "rgba(224, 224, 224, 0.5)",
      grid: {
        disabled: true,
      },
    });

    const maxValue = _.max(_.flatMap(summarizedData, obj => 
      _.values(_.omit(obj, 'date')) // date 필드를 제외한 모든 값을 배열로
  ));

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        strictMinMaxSelection: true,
        extraMin: 0,
        // extraMax: 0.3,
        max: maxValue*1.1,
        renderer: yRenderer,
      })
    );

  


    let yAxislabel = am5.Label.new(root, {
      rotation: 0,
      // text: unit,
      y: am5.p50,
      centerX: am5.p50,
      fill: "#FFF",
      //x: am5.p0,
      //centerY: am5.p0
    });

    yAxis.children.unshift(yAxislabel);


    yRenderer.grid.template.setAll({
      strokeOpacity: 0,
    });

    yRenderer.labels.template.setAll({
      paddingRight: 10,
      scale: 0.7,
      fill: "#525252",
    });

    const makeSeries = (name, fieldName, color) => {
      let series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: fieldName,
          categoryXField: "date",
          stroke: am5.color(color),
          fill: am5.color(color),
          legendValueText: "{valueY.formatNumber('#.00')}", // 소수점 첫째 자리까지 표현
          // tooltip: am5.Tooltip.new(root, {
          //   pointerOrientation: "horizontal",
          //   labelText: "[fontSize: 12px]{valueY}"
          // })
        })
      );

      series.strokes.template.setAll({
        strokeWidth: 1,
        strokeOpacity: 1,
      });

      series.data.setAll(summarizedData);

      series.appear();

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          locationY: 1,
          sprite: am5.Circle.new(root, {
            radius: 4,
            fill: am5.color(0xffffff),
            stroke: am5.color(color),
          }),
          
        });
      });
    };
    const seriesName = _.uniqBy(chartData2, 'room').map(v => v.room);


    const color_list = ['#2D87BB', '#A05195', '#F95D6A', '#64C2A6', '#AADEA7', '#FEAE65', '#F66D44']; // 색상을 16진수로 변경

    seriesName.forEach((room, index) => {
      makeSeries(room, room, color_list[index]);
    });

    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none"
    }));
    cursor.lineY.set("visible", false);

    var legend = chart.rightAxesContainer.children.push(am5.Legend.new(root, {
      width: 120,
      paddingLeft: 15,
      height: am5.percent(100)
    }));
    
    // When legend item container is hovered, dim all the series except the hovered one
    legend.itemContainers.template.events.on("pointerover", function(e) {
      var itemContainer = e.target;
    
      // As series list is data of a legend, dataContext is series
      var series = itemContainer.dataItem.dataContext;
    
      chart.series.each(function(chartSeries) {
        if (chartSeries != series) {
          chartSeries.strokes.template.setAll({
            strokeOpacity: 0.15,
            stroke: am5.color(0x000000)
          });
        } else {
          chartSeries.strokes.template.setAll({
            strokeWidth: 3
          });
        }
      })
    })
    
    // When legend item container is unhovered, make all series as they are
    legend.itemContainers.template.events.on("pointerout", function(e) {
      var itemContainer = e.target;
      var series = itemContainer.dataItem.dataContext;
    
      chart.series.each(function(chartSeries) {
        chartSeries.strokes.template.setAll({
          strokeOpacity: 1,
          strokeWidth: 1,
          stroke: chartSeries.get("fill")
        });
      });
    })
    
    legend.itemContainers.template.set("width", am5.p100);
    legend.valueLabels.template.setAll({
      width: am5.p100,
      textAlign: "right",
      fontWeight:"400", 
      fill: am5.color(0x000000),
      fontSize: 12
    });

    legend.labels.template.setAll({
      fontSize: 12,
      fill: am5.color(0x000000),
      fontWeight: "400"
    });

    // legend.markerRectangles.template.setAll({
    //   cornerRadiusTL: 10,
    //   cornerRadiusTR: 10,
    //   cornerRadiusBL: 10,
    //   cornerRadiusBR: 10
    // });
    
    legend.itemContainers.template.events.on("pointerover", (e) => {
      let itemContainer = e.target;
      let series = itemContainer.dataItem.dataContext;
      series.strokes.template.setAll({
        strokeWidth: 3
      });
    });
    
    legend.itemContainers.template.events.on("pointerout", (e) => {
      let itemContainer = e.target;
      let series = itemContainer.dataItem.dataContext;
      series.strokes.template.setAll({
        strokeWidth: 1
      });
    });

    legend.data.setAll(chart.series.values);
    


    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(1000, 100);

    return () => {

      root && root.dispose();

    };
  }, [
    chartData2, chart_id, unit
  ]);




  return (
    <div style={{ position: 'relative', width: '100%', height: height }}>
      <Box
        sx={{
          padding: '20px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '10px',
            height: 28,
            borderBottom: '1px solid #D1D1D1',
          }}
        >
          <TileTitle>{title}</TileTitle>
          <div
            style={{
              zIndex: 99999,
              fontSize: 12,
              marginRight: 8,
              // height: 40,
              // width: 325,
              whiteSpace: 'nowrap',
            }}

          >{isNaN(totalArea)?"-":totalArea.toFixed(2)} MD/평</div>
        </Box>

        <Box sx={{ position: 'relative', flexGrow: 1 }}>
          {chartData && chartData.month && chartData.month.length > 0 ? (

            <>
              <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <ToggleButtonGroup
                  className="no-drag-button"
                  size="small"
                  onChange={onCheckedChange}
                  value={checked}
                  exclusive
                  aria-label="baseunit"
                >
                  <ToggleButton value="월간" aria-label="monthly">
                    월간
                  </ToggleButton>
                  <ToggleButton value="주간" aria-label="weekly">
                    주간
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>

              <div id={chart_id} style={{ position: 'absolute', bottom: 0, width: '100%', height: 'calc(100% - 40px)' }} />
            </>
          )
            : (
              // Show a message if there's no data
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <Typography variant="body2">데이터가 존재하지 않습니다.</Typography>
              </Box>
            )}
        </Box>
      </Box>
    </div>
  );
}



export default MLineChartWithTitle